// components/focusMode/FocusModeOverlay.jsx
import { useEffect, useCallback, useState } from "react";
import { createPortal } from "react-dom";
import  "./focusModeOverlay.css";

function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [locked]);
}

function useEscapeToClose(enabled, onClose) {
  useEffect(() => {
    if (!enabled) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled, onClose]);
}

export default function FocusModeOverlay({
  isOpen,
  onClose,
  children,
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);
  useLockBodyScroll(isOpen);
  useEscapeToClose(isOpen, onClose);

  // Helpful for Quill/textarea sizing when popping into fixed overlay
  useEffect(() => {
    if (!isOpen) return;
    requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
  }, [isOpen]);

  if (!isOpen || !mounted) return null;

  return createPortal(
    <div
      className="focusOverlay"
      role="dialog"
      aria-modal="true"
    >
      <div className="focusBody">{children}</div>
    </div>,
    document.body
  );
}